var _path, _path2, _path3, _path4, _line, _path5, _line2, _line3, _path6, _path7, _line4, _line5, _path8, _path9, _line6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24389 10.4707C2.44943 10.031 2.89092 9.75 3.37629 9.75H22.9379C23.6095 9.75 24.161 10.2806 24.187 10.9517L24.7168 24.6556C24.7302 25.0036 24.5979 25.3415 24.3516 25.5877L22.1916 27.7477C21.753 28.1864 21.0591 28.237 20.5614 27.8667L1.75626 13.8721C1.28017 13.5178 1.11882 12.8776 1.37012 12.34L2.24389 10.4707Z",
    fill: "white",
    stroke: "#747272",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 14C0.75 13.3096 1.30964 12.75 2 12.75H20.0548C20.7316 12.75 21.2855 13.2887 21.3043 13.9653L21.6932 27.9653C21.7127 28.669 21.1476 29.25 20.4437 29.25H2C1.30964 29.25 0.75 28.6904 0.75 28V14Z",
    fill: "white",
    stroke: "#747272",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20.5C15.5 23.2614 13.2614 25.5 10.5 25.5C7.73858 25.5 5.5 23.2614 5.5 20.5C5.5 17.7386 7.73858 15.5 10.5 15.5C13.2614 15.5 15.5 17.7386 15.5 20.5Z",
    stroke: "#717070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2969 17.6479V20.7035H12.7413",
    stroke: "#717070"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 12.2929,
    x2: 23.2929,
    y2: 10,
    stroke: "#747272",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2C6.5 1.17157 7.17157 0.5 8 0.5H16C16.8284 0.5 17.5 1.17157 17.5 2V10.5769H6.5V2Z",
    fill: "white",
    stroke: "#717070"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4.5,
    x2: 11.5814,
    y2: 4.5,
    stroke: "#717070"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 5.76318,
    x2: 11.5814,
    y2: 5.76318,
    stroke: "#717070"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.5H16.0814",
    stroke: "#717070"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.418 5.76318H15.9994",
    stroke: "#717070"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.00391,
    y1: 7.5,
    x2: 11.5853,
    y2: 7.5,
    stroke: "#717070"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 8.00391,
    y1: 8.7627,
    x2: 11.5853,
    y2: 8.7627,
    stroke: "#717070"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.418 7.5H15.9994",
    stroke: "#717070"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.418 8.7627H15.9994",
    stroke: "#717070"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 2.75,
    x2: 17,
    y2: 2.75,
    stroke: "#747272",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/check-in.f297ecb935e867cb00827264d46fc12d.svg";
export { ForwardRef as ReactComponent };